import React from 'react'
import Root from './routes/MainRoutes';
import DevInit from './components/dev/DevInit';
// import { Provider } from "react-redux";

function App() {
  return (

    <React.Fragment>
         <Root />
         <DevInit/>
    </React.Fragment>

  );
}

export default App;
